import { api } from './api';
import type {
  CrearMermaDTO,
  CrearMermasMultiplesDTO,
  AprobarMermaDTO,
  RechazarMermaDTO,
  ActualizarMermaDTO,
  FiltrosMerma,
  FiltrosSugerencias,
  FiltrosEstadisticas,
  MermasResponse,
  MermaResponse,
  MotivosResponse,
  SugerenciasResponse,
  EstadisticasResponse
} from '../types/mermas';



const mermasService = {
  // Listar mermas con filtros y paginación
  getAll: async (filtros: FiltrosMerma = {}): Promise<MermasResponse> => {
    const response = await api.get<MermasResponse>('/mermas', { params: filtros });
    return response.data;
  },

  // Obtener una merma por ID
  getById: async (id: number): Promise<MermaResponse> => {
    const response = await api.get<MermaResponse>(`/mermas/${id}`);
    return response.data;
  },

  // Crear una nueva merma
  create: async (payload: CrearMermaDTO): Promise<MermaResponse> => {
    const response = await api.post<MermaResponse>('/mermas', payload);
    return response.data;
  },

  // Crear varias mermas
  createMultiples: async (payload: CrearMermasMultiplesDTO): Promise<MermasResponse> => {
    const response = await api.post<MermasResponse>('/mermas/multiples', payload);
    return response.data;
  },

  // Aprobar una merma
  aprobar: async (id: number, payload: AprobarMermaDTO): Promise<MermaResponse> => {
    const response = await api.put<MermaResponse>(`/mermas/${id}/aprobar`, payload);
    return response.data;
  },

  // Rechazar una merma
  rechazar: async (id: number, payload: RechazarMermaDTO): Promise<MermaResponse> => {
    const response = await api.put<MermaResponse>(`/mermas/${id}/rechazar`, payload);
    return response.data;
  },

  // Actualizar una merma
  update: async (id: number, payload: ActualizarMermaDTO): Promise<MermaResponse> => {
    const response = await api.put<MermaResponse>(`/mermas/${id}`, payload);
    return response.data;
  },

  // Eliminar una merma
  delete: async (id: number): Promise<MermaResponse> => {
    const response = await api.delete<MermaResponse>(`/mermas/${id}`);
    return response.data;
  },

  // Obtener motivos de merma
  getMotivos: async (): Promise<MotivosResponse> => {
    const response = await api.get<MotivosResponse>('/mermas/motivos');
    return response.data;
  },

  // Obtener sugerencias de merma
  getSugerencias: async (filtros: FiltrosSugerencias = {}): Promise<SugerenciasResponse> => {
    const response = await api.get<SugerenciasResponse>('/mermas/sugerencias', { params: filtros });
    return response.data;
  },

  // Obtener estadísticas de mermas
  getEstadisticas: async (filtros: FiltrosEstadisticas = {}): Promise<EstadisticasResponse> => {
    const response = await api.get<EstadisticasResponse>('/mermas/estadisticas', { params: filtros });
    return response.data;
  },
};

export default mermasService;
